import React from 'react'
import Logo from '../assets/logo-3.2.png'

function Sphere({ children, size = 300, dark = "true" }) {
    return (
        <div className="logo">
            <img
                className="logo-img"
                src={Logo}
                alt="logo"
                style={{ width: size, height: 'auto' }}
            >
                {children}
            </img>
        </div>
    )
}

export default Sphere